import axios from "axios";
import { API_CASES_DEMO, API_REPORTS, API_URL, API_CLOUD, API_CREDIT_CORE } from "../Constants";

const baseUrl = API_URL;
const baseUrlCloud = API_CLOUD;
const urlReports = API_REPORTS;

/**
 * Cliente HTTP principal de la app (`baseURL` desde Constants). Rutas como POST `/v1/step-connections` se resuelven como baseURL + path (ver `whatsappFlowApi.js`).
 */
export const axiosClient = axios.create({
  baseURL: baseUrl,
  headers: {
    Authorization: "Bearer 73455f17-e348-41cd-b475-15376eb40621",
  },
});


export const axiosClientCertificados = axios.create({
  baseURL: baseUrl,
  headers: {
    Authorization: "Bearer 7f3a1b8c-92e5-4d1a-b6f2-08c9d4a3e7b1",
  },
});

axiosClientCertificados.interceptors.request.use((config) => {
  console.log("[Certificados] Request:", config.method?.toUpperCase(), config.url);
  return config;
});

export const axiosClientCloud = axios.create({
  baseURL: baseUrlCloud,
  headers: {
    Authorization: "Bearer 73455f17-e348-41cd-b475-15376eb40621",
  },
});

export const axiosClientCreditCore = axios.create({
  baseURL: API_CREDIT_CORE,
  headers: {
    Authorization: "Bearer 73455f17-e348-41cd-b475-15376eb40621",
  },
});

export const axiosClientReports = axios.create({
  baseURL: urlReports,
});

export const axiosClientCases = axios.create({
  baseURL: API_CASES_DEMO,
  headers: {
    "Content-Type": "application/json",
  },
});

export const uploadImage = (imageKey, setState) => {
  console.log("Entre al upload");
  if (imageKey) {
    axiosClient
      .get(`/v1/s3/url/${imageKey}`)
      .then((response) => {
        setState(response.data);
      })
      .catch((error) => {
        console.log("Error fetching image: " + error.message);
      });
  }
};

export const importCampaignCsv = (userUuid, shortName, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosClient.post(
    `/v1/moonflow/campaigns/import/${userUuid}?shortName=${encodeURIComponent(shortName)}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    }
  );
};
